import React, { useContext, useEffect } from 'react';
import { LeReacteurContext } from '../../Layout';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { FormContainer, PerksWrapper } from '../elements';
import { DateInput, BackButton, ErrorMessage } from '../../Form';
import { InputForm, Label, NextBtn, InputPhone } from '../../Form/elements';
import { flags } from '../../Icons/Flags';
import { mediaQueries } from 'src/style/breakpoints';
import { isPossiblePhoneNumber } from 'react-phone-number-input';
import Perks from '../Perks';

const SecondBlockSchema = Yup.object().shape({
  firstName: Yup.string().required('Champ obligatoire'),
  lastName: Yup.string().required('Champ obligatoire'),
  birthDate: Yup.string().when('offerType', {
    is: 'long',
    then: (schema) => schema.typeError('Date non valide').required('Champ obligatoire'),
    otherwise: (schema) => schema.nullable(),
  }),
  companyName: Yup.string(),
  job: Yup.string(),
  email: Yup.string()
    .matches(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Email non valide')
    .required('Champ obligatoire'),
  phoneNumber: Yup.string()
    .required('Champ obligatoire')
    .test({
      test: (num) => {
        if (num) {
          if (num.indexOf('+330') !== -1) {
            num = num.replace('+330', '+33');
            return isPossiblePhoneNumber(num);
          } else {
            return isPossiblePhoneNumber(num);
          }
        }
      },
      message: 'Numéro de téléphone non valide',
    }),
  // .required('Champ obligatoire'),
});

const SecondBlock = ({ onSubmit, onBackClicked, error, GRCtoken, stepsData, step2Data }) => {
  const { dtlVirtualPageView } = useContext(LeReacteurContext);
  const initialValues = {
    firstName: '',
    lastName: '',
    companyName: '',
    job: '',
    birthDate: '',
    email: '',
    phoneNumber: '',
    ...(step2Data || {}),
    offerType: stepsData.step1.offerType,
  };

  useEffect(() => {
    if (window) {
      window.scrollTo({
        top: 90,
        left: 0,
        behavior: 'smooth',
      });
    } else {
      return null;
    }
  }, []);

  useEffect(() => {
    dtlVirtualPageView('bootcamp', '2', 'Coordonnées');
  }, []);

  return (
    <FormContainer>
      <Formik
        initialValues={{
          ...initialValues,
        }}
        validationSchema={SecondBlockSchema}
        validateOnMount={true}
        // validate={(values) => {
        //   manager.set(FORM_TOKEN, values);
        // }}
        onSubmit={(values) => {
          const answers = {
            firstName: values.firstName,
            lastName: values.lastName,
            companyName: values.companyName,
            job: values.job,
            birthDate: values.birthDate,
            email: values.email,
            phoneNumber: values.phoneNumber,
          };
          onSubmit(answers);
        }}
      >
        {({ errors, handleChange, setFieldValue, touched, values, isSubmitting }) => {
          const isDisabled = () => {
            try {
              SecondBlockSchema.validateSync(values);
              return false;
            } catch (error) {
              return true;
            }
          };
          return (
            <Form css={{ maxWidth: 585, width: '100%' }}>
              <div>
                {/*  <pre
                  css={{
                    backgroundColor: 'red',
                    padding: 10,
                    width: 600,
                    whiteSpace: 'pre-wrap',
                    overflow: 'auto',
                    wordWrap: 'break-word',
                    position: 'fixed',
                    bottom: 0,
                    right: 0,
                    zIndex: 2000,
                  }}
                >
                  {JSON.stringify({ ...stepsData, ...values })}
                </pre> */}
                <div
                  css={{
                    display: 'flex',
                    flexDirection: 'column',
                    [mediaQueries.tabletPortraitUp]: {
                      flexDirection: 'row',
                    },
                  }}
                >
                  <div>
                    <Label>Prénom</Label>
                    <InputForm
                      errorStyle={errors.firstName && touched.firstName ? true : false}
                      type="firstName"
                      name="firstName"
                      onChange={handleChange}
                      value={values.firstName}
                    />
                    <ErrorMessage
                      isVisible={errors.firstName && touched.firstName}
                      message={errors.firstName}
                    />
                  </div>
                  <div
                    css={{
                      marginTop: 50,
                      [mediaQueries.tabletPortraitUp]: {
                        marginTop: 0,
                        marginLeft: 25,
                      },
                    }}
                  >
                    <Label>Nom</Label>
                    <InputForm
                      type="lastName"
                      name="lastName"
                      value={values.lastName}
                      onChange={handleChange}
                      errorStyle={errors.lastName && touched.lastName ? true : false}
                    />
                    <ErrorMessage
                      isVisible={errors.lastName && touched.lastName}
                      message={errors.lastName}
                    />
                  </div>
                </div>
                {stepsData.step1.offerType === 'long' ? (
                  <>
                    <Label
                      css={{
                        marginTop: 50,
                        [mediaQueries.tabletPortraitUp]: {
                          marginTop: 50,
                        },
                      }}
                    >
                      Date de naissance
                    </Label>
                    <DateInput
                      value={values.birthDate}
                      errors={errors.birthDate && touched.birthDate}
                      onChange={(date) => {
                        setFieldValue('birthDate', date);
                      }}
                    />
                    <ErrorMessage
                      isVisible={errors.birthDate && touched.birthDate}
                      message={errors.birthDate}
                    />
                  </>
                ) : (
                  <div
                    css={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginTop: 50,
                      [mediaQueries.tabletPortraitUp]: {
                        flexDirection: 'row',
                      },
                    }}
                  >
                    <div>
                      <Label>Entreprise</Label>
                      <InputForm
                        name="companyName"
                        type="text"
                        value={values.companyName}
                        onChange={handleChange}
                        errorStyle={errors.companyName && touched.companyName ? true : false}
                      />
                      <ErrorMessage
                        isVisible={errors.companyName && touched.companyName}
                        message={errors.companyName}
                      />
                    </div>
                    <div
                      css={{
                        marginTop: 50,
                        [mediaQueries.tabletPortraitUp]: {
                          marginTop: 0,
                          marginLeft: 25,
                        },
                      }}
                    >
                      <Label>Poste occupé</Label>
                      <InputForm
                        name="job"
                        type="text"
                        value={values.job}
                        onChange={handleChange}
                        errorStyle={errors.job && touched.job ? true : false}
                      />
                      <ErrorMessage isVisible={errors.job && touched.job} message={errors.job} />
                    </div>
                  </div>
                )}
                <div
                  css={{
                    display: 'flex',
                    marginTop: 50,
                    flexDirection: 'column',
                    [mediaQueries.tabletPortraitUp]: {
                      flexDirection: 'row',
                      marginTop: 50,
                    },
                  }}
                >
                  <div>
                    <Label>Email</Label>
                    <InputForm
                      name="email"
                      type="text"
                      value={values.email}
                      onChange={handleChange}
                      errorStyle={errors.email && touched.email ? true : false}
                    />
                    <ErrorMessage
                      isVisible={errors.email && touched.email}
                      message={errors.email}
                    />
                  </div>
                  <div
                    css={{
                      marginTop: 50,
                      [mediaQueries.tabletPortraitUp]: {
                        marginTop: 0,
                        marginLeft: 25,
                      },
                    }}
                  >
                    <Label>Téléphone</Label>
                    <InputPhone
                      errors={errors}
                      touched={touched}
                      placeholder="Entrez votre numéro"
                      autoComplete="tel"
                      country="FR"
                      defaultCountry="FR"
                      flags={flags}
                      displayInitialValueAsLocalNumber={true}
                      value={values.phoneNumber}
                      onChange={(number) => {
                        setFieldValue('phoneNumber', number);
                      }}
                    />
                    <ErrorMessage
                      isVisible={errors.phoneNumber && touched.phoneNumber}
                      message={errors.phoneNumber}
                    />
                  </div>
                </div>
              </div>

              <div
                css={{
                  display: 'flex',
                  alignItems: 'baseline',
                  justifyContent: 'space-between',
                  [mediaQueries.tabletPortraitUp]: {
                    maxWidth: 465,
                  },
                  [mediaQueries.tabletLandscapeUp]: {
                    maxWidth: 585,
                  },
                }}
              >
                {/* <BackButton onClick={onBackClicked} /> */}
                <BackButton
                  onClick={() => {
                    onBackClicked();
                  }}
                />
                <NextBtn
                  data-cy="suivant2"
                  type="submit"
                  disabledStyle={isDisabled()}
                  disabled={isSubmitting}
                >
                  Suivant
                </NextBtn>
              </div>
              {error && (
                <ErrorMessage
                  css={{ textAlign: 'end' }}
                  isVisible={error}
                  message={
                    GRCtoken
                      ? 'Une erreur est survenue.'
                      : "Une erreur est survenue ! Vérifiez que vous n'êtes pas derrière un VPN. Si le problème persiste, merci de nous contacter directement."
                  }
                />
              )}
            </Form>
          );
        }}
      </Formik>
      <PerksWrapper>
        <Perks
          certification={stepsData.step1.certification}
          courseType={stepsData.step1.courseType}
          format={stepsData.step1.format}
          rncpFunding={stepsData.step1.rncpFunding}
          offerType={stepsData.step1.offerType}
        />
      </PerksWrapper>
    </FormContainer>
  );
};
export default SecondBlock;
